<template>
  <div id="chart-table-box">
    <chart-title leftTitle="OMS异常订单实时数据"></chart-title>
    <div id="chart-table">
      <div class="table-title-item">
        <dv-decoration-7 class="table-title table-title-first"
          ><span class="table-title-text"
            >OMS订单打回实时数据</span
          ></dv-decoration-7
        >
        <el-button
          type="primary"
          slot="detail"
          size="mini"
          style="margin-right: 20px"
          >详 情</el-button
        >
      </div>
      <dv-scroll-board
        :config="config"
        style="width: 100%; height: 20%; margin-top: 10px"
      />
      <div class="table-title-item">
        <dv-decoration-7 class="table-title"
          ><span class="table-title-text"
            >OMS订单内补实时数据</span
          ></dv-decoration-7
        >
        <el-button
          type="primary"
          slot="detail"
          size="mini"
          style="margin-right: 20px"
          >详 情</el-button
        >
      </div>
      <dv-scroll-board
        :config="config"
        style="width: 100%; height: 20%; margin-top: 10px"
      />
      <div class="table-title-item">
        <dv-decoration-7 class="table-title"
          ><span class="table-title-text"
            >OMS订单售后实时数据</span
          ></dv-decoration-7
        >
        <el-button
          type="primary"
          slot="detail"
          size="mini"
          style="margin-right: 20px"
          >详 情</el-button
        >
      </div>
      <dv-scroll-board
        :config="config"
        style="width: 100%; height: 20%; margin-top: 10px"
      />
    </div>
  </div>
</template>

<script>
import resize from "@/utils/resize";
import ChartTitle from "../../../components/chartTitle";
export default {
  mixins: [resize],
  name: "left_5",
  components: { ChartTitle },
  data() {
    return {
      config: {
        rowNum: 3,
        headerBGC: "transparent", // 表头背景色
        oddRowBGC: "transparent", // 奇数行背景色
        evenRowBGC: "transparent", // 偶数行背景色
        waitTime: 2000, // 轮播时间间隔(ms)
        align: [
          "center",
          "center",
          "center",
          "center",
          "center",
          "center",
          "center",
        ],
        columnWidth: ["", "", 70, 70, ""],
        data: [
          [
            `<span style="color:#409EFF">审图打回：工号</span>`,
            `<span style="color:#409EFF">202212160001</span>`,
            `<span style="color:#409EFF">商家名</span>`,
            `<span style="color:#409EFF">客户名</span>`,
            `<span style="color:${this.getColor(-2)}">环节延期-2天</span>`,
          ],
          [
            `<span style="color:#409EFF">审图打回：工号</span>`,
            `<span style="color:#409EFF">202212160001</span>`,
            `<span style="color:#409EFF">商家名</span>`,
            `<span style="color:#409EFF">客户名</span>`,
            `<span style="color:${this.getColor(0)}">环节延期0天</span>`,
          ],
          [
            `<span style="color:#409EFF">审图打回：工号</span>`,
            `<span style="color:#409EFF">202212160001</span>`,
            `<span style="color:#409EFF">商家名</span>`,
            `<span style="color:#409EFF">客户名</span>`,
            `<span style="color:${this.getColor(-2)}">环节延期-2天</span>`,
          ],
          [
            `<span style="color:#409EFF">审图打回：工号</span>`,
            `<span style="color:#409EFF">202212160001</span>`,
            `<span style="color:#409EFF">商家名</span>`,
            `<span style="color:#409EFF">客户名</span>`,
            `<span style="color:${this.getColor(2)}">环节延期2天</span>`,
          ],
          [
            `<span style="color:#409EFF">审图打回：工号</span>`,
            `<span style="color:#409EFF">202212160001</span>`,
            `<span style="color:#409EFF">商家名</span>`,
            `<span style="color:#409EFF">客户名</span>`,
            `<span style="color:${this.getColor(0)}">环节延期0天</span>`,
          ],
        ],
      },
    };
  },
  props: {},
  created() {},
  mounted() {},

  methods: {
    getColor(val) {
      if (val == 0) {
        return "#fee588";
      } else if (val > 0) {
        return "#F56C6C";
      } else {
        return "#409EFF";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#chart-table-box {
  // background: rgba(125, 155, 243, 0.2);
  height: 66vh;

  #chart-table {
    background: transparent;
    height: calc(100% - 30px);

    .table-title {
      width: 180px;
      height: 30px;
      margin: 30px 0px 0px 5px;
      justify-content: flex-start;
      .table-title-text {
        color: #7ec699;
        font-weight: 700;
      }
    }
    .table-title-first {
      margin: 20px 0px 0px 5px !important;
    }
  }
  .table-title-item {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
  }
}
</style>

